import React from "react";
import { func } from "prop-types";

import CrossIcon from "../../atoms/icons/cross-icon";

import "./settingsView.m.css";

const SettingsView = ({ navigateToPage, closePopup }) => {
  const dashboardClick = () => {
    closePopup();
    navigateToPage("/dashboard");
  };

  return (
    <div styleName="wrapper">
      <div styleName="content-link-wrapper">
        <div styleName="settings-link" onClick={dashboardClick}>
          My Profile
        </div>
        {/**
          2nd Phase
          <Link styleName="settings-link" href="">
            Change Password
          </Link>
        */}
        <a styleName="settings-link" href="/contact-us">
          Contact Us
        </a>
        <a styleName="settings-link" href="/faq">
          FAQs
        </a>
      </div>

      <div styleName="retry-subscription-btn">Retry Subscription</div>

      <div styleName="cross-icon" onClick={closePopup}>
        <CrossIcon width={20} height={20} />
      </div>
    </div>
  );
};

SettingsView.propTypes = {
  navigateToPage: func,
  closePopup: func,
};

export default SettingsView;
